import React from "react";

export default function CancellationRefund() {
  return (
    <div className="p-4 d-flex align-items-center justify-content-center">
      <div className="text-dark" style={{ maxWidth: "1000px", width: "95vw" }}>
        <h3>RETURN POLICY</h3>
        <br />
        <p>Last updated June 03, 2023</p>
        <br />
        <p>
          Thank you for your purchase. We hope you are happy with your purchase.
          However, if you are not completely satisfied with your purchase for
          any reason, you may return it to us for a full refund only. Please see
          below for more information on our return policy.
        </p>
        <br />
        <h3>RETURNS</h3>
        <p>
          All returns must be postmarked within one (1) days of the purchase
          date. All returned items must be in new and unused condition, with all
          original tags and labels attached
        </p>
        <br />
        <h3>RETURN PROCESS</h3>
        <p>
          To return an item, please email customer service at{" "}
          <a href="mailto:support@essaygrad.com">support@essaygrad.com</a> to
          obtain a Return Merchandise Authorization (RMA) number. After
          receiving a RMA number place the item
        </p>
        <p>
          your proof of purchase, then mail your return to the securely in its
          original packaging and include following address
        </p>
        <br />
        <p> Essay Grad</p>
        <p>Attn: Returns</p>
        <p>RMA #</p>
        <p>________</p>
        <p>________, ________</p>
        <p>United States</p>
        <br />
        <br />
        <p>
          Please note, you will be responsible for all return shipping charges.
          We strongly recommend that you use a trackable method to mail your
          return.
        </p>
        <br />
        <h3>REFUNDS</h3>
        <p>
          After receiving your return and inspecting the condition of your item,
          we will process your return. Please allow at least five (5) days from
          the receipt of your item to process your return. Refunds may take 1-2
          billing cycles to appear on your credit card statement, depending on
          your credit
        </p>
        <p>
          card company. We will notify you by email when your return has been
          processed.
        </p>
        <br />
        <h3>EXCEPTIONS</h3>
        <p>
          For defective or damaged products, please contact us at the contact
          details below to arrange a refund or exchange.
        </p>
        <br />
        <h3>QUESTIONS</h3>
        <p>
          If you have any questions concerning our return policy, please contact
          us at:
        </p>
        <p>
          <a href="mailto:support@essaygrad.com">support@essaygrad.com</a>
        </p>
      </div>
    </div>
  );
}
